import { render, staticRenderFns } from "./ModalSelectPE.vue?vue&type=template&id=56c4bd84&"
import script from "./ModalSelectPE.vue?vue&type=script&lang=js&"
export * from "./ModalSelectPE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports